module.exports = __webpack_public_path__ + "static/media/btptp_m.3799825d.png";